import {all} from 'redux-saga/effects';

import {createFetchSagaLatest} from 'utils/sagas';

import {fetchLookerRevenueUrl as fetchLookerRevenueUrlAction} from './';

import {fetchLookerRevenueUrl} from 'sdk/reporting';

function* lookerRevenueReportingSaga() {
  yield all([
    createFetchSagaLatest(fetchLookerRevenueUrlAction, fetchLookerRevenueUrl)
  ]);
}

export default lookerRevenueReportingSaga;
